const getClassSpecIcon = (_class, spec) => {
  return `https://static.bigbrain.gg/wow/specs/${_class.toLowerCase().replace(" ", "_")}_${spec.toLowerCase()}.png`;
};

const getSpecIcon = (_class, spec) => {
  return `https://static.bigbrain.gg/wow/spec-icons/${_class}-${spec}.jpg`;
};

export { getSpecIcon, getClassSpecIcon };
